"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}
    ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.None)};
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  align-items: center;
  width: 100%;
`;
//# sourceMappingURL=CreateTextOverview.style.js.map